import Content from "./content.js";

export default Content;
